import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getPointTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}pointtype`);
      let data = response["data"];
      context.commit("updatePointTypesData", data);
    },
    async createPointTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}pointtype/store`, body, config);
      context.dispatch("getPointTypesData");
    },
    async pushPointTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}pointtype/update`, body, config);
      context.dispatch("getPointTypesData");
    },
    async destroyPointTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}pointtype/destroy`, body, config);
      context.dispatch("getPointTypesData");
    }
  },
  mutations: {
    updatePointTypesData(state, pointTypesData) {
      state.pointTypesData = pointTypesData;
    }
  },
  state: {
    pointTypesData: []
  },
  getters: {
    allPointTypesData(state) {
      return state.pointTypesData;
    }
  }
};
